import { createFeatureSelector, createSelector } from '@ngrx/store';
import { APP_FEATURE_KEY, State, AppPartialState } from './app.reducer';

export const getAppState = createFeatureSelector<AppPartialState, State>(
  APP_FEATURE_KEY
);

export const getAppLoading = createSelector(
  getAppState,
  (state: State) => state.loading
);

export const getAppError = createSelector(
  getAppState,
  (state: State) => state.error
);

export const getLayout = createSelector(
  getAppState,
  (state: State) => state.layout
);
